const C = require("../constants");

const providerDialog = (data) => {
    return {
        type: C.PROVIDER_DIALOG,
        data
    }
};

export {providerDialog};


// WEBPACK FOOTER //
// ./src/actions/ProviderDialogAction.js